import axios from "axios";
import getToken from "../../../config/getToken";
import { env } from "../../../env";
import { convertFileToBase64Dynamic } from "../../../utils/functions";
import { CODES } from "../../../consts/codes";

//CARGA

/**
 * Petición que carga una lista de empleados
 * @param {*} data información de la carga
 * @returns respuesta de carga
 */
export async function UploadEmployeesFile(data) {
  const token = await getToken();
  const { fileContent } = data;

  const formData = new FormData();

  formData.append("file", fileContent);

  const finalData = await convertFileToBase64Dynamic(formData, data);

  return axios({
    method: "POST",
    data: finalData,
    url: "employeefile/upload",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Trae la lista de cargas de empleados
 * @param {String} mainUser correo del mainUser
 * @param {String} idRole id del rol del usuario
 * @returns lista de cargas de empleados
 */
export async function GetEmployees(mainUser, idRole) {
  const token = await getToken();

  return axios({
    method: "GET",
    url: `employeefile/list/${mainUser}/${idRole}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Petición que trae la plantilla del archivo de empleados
 * @returns plantilla codificada
 */
export async function DownloadTemplateMastersTraders(data) {
  const token = await getToken();
  const { master } = data;

  return axios({
    method: "GET",
    url: `${master}/downloads/templates`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Descarga del template para
 * @returns plantilla codificada
 */
export async function DownloadCredentialsTemplate() {
  const token = await getToken();

  return axios({
    method: "GET",
    url: "masters/downloads/infonavitcredentials/template",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Petición que trae la guía del maestro seleccionado
 * @returns guía codificada
 */
export async function DownloadGuideMastersTraders(data) {
  const token = await getToken();
  const { master } = data;
  return axios({
    method: "GET",
    url: `${master}/downloads/guides`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite utilizar el servicio de generación de
 * petición de descarga del maestro seleccionado
 */

export async function GenerateDownloadMastersTraders(data, master) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `${master}/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Utilizar el servicio para obtener los archivos de penalidades o metas descargados
 * @param {*} data // Datos de la compañía y modulo a consultar
 * @returns
 */
export async function ListDownloadMastersTraders(data) {
  const token = await getToken();

  return axios({
    method: "POST",
    data: data,
    url: `masters/downloads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
/**
 *
 * Función para consumir el servicio que devuelve la lista de proveedores por país
 *
 * @param {*} data
 * @returns resultado de la petición de axios (lista de proveedores)
 */
export async function GetSuppliersService(data) {
  const token = await getToken();

  return axios({
    method: "GET",
    url: "companies",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite utilizar el servicio de descarga del archivo
 */

export async function DownloadTradersOnDownload(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}
